import { render, staticRenderFns } from "./StickerPrint.vue?vue&type=template&id=13b46be6&"
import script from "./StickerPrint.vue?vue&type=script&lang=js&"
export * from "./StickerPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports